export const validateAmount = (value, {minimumAmount, currencySymbol = ''} = {}) => {
    const numeric = Number(value);

    if (!value || !numeric || numeric <= 0) return 'Amount is required';

    if (minimumAmount && numeric < minimumAmount) {
        return `Minimum amount is ${currencySymbol}${minimumAmount}`;
    }

    return '';
};
